import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vraag-project',
  templateUrl: './vraag-project.component.html',
  styleUrls: ['./vraag-project.component.scss']
})
export class VraagProjectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
